<template>
  <!-- 设备 -->
  <div class="box-main">
    <div class="main">
      <div>
        <div class="main-title">
          <img
            class="arrow-left"
            src="../../../assets/img/arrow-left.svg"
            alt=""
            @click="pushBack"
          />
            <span class="ml20">子设备({{ this.dev_name }})</span>
          </div>
      </div>
      <div class="headerContainer"></div>
      <div class="main-center h34">
        <!-- <v-form ref="form" :model="ruleForm" :rules="rules" class="searchform">
          <v-form-item prop="dev_key" :required="false" >
            <v-input
            v-model="ruleForm.dev_key"
            placeholder="请输入设备KEY"
          ></v-input>
          </v-form-item>
        </v-form>
        <v-button class="ml10" type="primary" name="" @click="handleSearch">查询</v-button>
        <v-button class="" type="info" name="" @click="clear">重置</v-button> -->
      </div>
      <div>
        <vxe-table row-id="id" :data="table" align="center" @filter-change="filterChangeEvent" :filter-config="{remote: true}">
          <vxe-table-column
            field="dev_name"
            show-overflow
            min-width="80"
            title="设备名称"
          ></vxe-table-column>
          <vxe-table-column
            field="dev_key"
            show-overflow
            min-width="120"
            title="设备KEY"
          ></vxe-table-column>
          <vxe-table-column
            field="dev_mac"
            show-overflow
            min-width="120"
            title="设备MAC"
          ></vxe-table-column>
          <vxe-table-column
            field="product_name"
            show-overflow
            min-width="120"
            title="所属产品"
          ></vxe-table-column>
          <vxe-table-column
            field=""
            show-overflow
            min-width="120"
            title="设备状态"
            v-slot="slotProps"
            :filter-multiple="false"
            :filters="filtersList"
          >
            <span :class="slotProps.row.dev_status == 'online' ? 'online':'offline'">{{ slotProps.row.dev_status == 'online' ? '在线' : '离线' }}</span>
          </vxe-table-column>
          <vxe-table-column
            field="group_name"
            show-overflow
            min-width="120"
            title="所在分组"
          ></vxe-table-column>
          <vxe-table-column
            field="created_at_str"
            show-overflow
            min-width="120"
            title="创建时间"
          ></vxe-table-column>
          <vxe-column title="操作" min-width="140">
            <template v-slot="slotProps">
              <span class="handle-button"
                ><v-button
                  size="S"
                  type="text"
                  name="btn-text1"
                  slot="reference"
                  @click="openViewModel(slotProps.row)"
                  >查看</v-button
                ></span
              >
              <span class="handle-button"
                ><v-button
                  size="S"
                  type="text"
                  name="btn-text1"
                  slot="reference"
                  @click="showDelModel(slotProps.row)"
                  >删除</v-button
                ></span
              >
              <span class="handle-button"
                ><v-button
                  size="S"
                  type="text"
                  name="btn-text1"
                  slot="reference"
                  @click="showNoticeModel(slotProps.row)"
                  >日志上报</v-button
                ></span
              >
            </template>
          </vxe-column>
        </vxe-table>
      </div>
      <v-pagination
        v-if="total"
        @change-page="changePage"
        @change-size="changeSize"
        :total="total"
        name="page-basic"
        is-show-total
        is-change-size
        is-input-page
        :current-page="this.currentPage"
      ></v-pagination>
    </div>

    <NewDevice
      :showInputDialog.sync="NewDeviceloading"
      ref="NewDevice"
      @getData="getData"
    ></NewDevice>
    <NewDeviceBatch
      :showInputDialog.sync="NewDeviceBatchloading"
      ref="NewDeviceBatch"
      @getData="getData"
    ></NewDeviceBatch>
    <Del
      :showInputDialog.sync="Delloading"
      :devId="devId"
      ref="Del"
      @getData="getData"
    ></Del>
    <Notice
      :showInputDialog.sync="Noticeloading"
      :product_key="product_key"
      :device_key="device_key"
      ref="Del"
    ></Notice>
    <!-- <Upgrade
      :showInputDialog.sync="Upgradeloading"
      :product_key="product_key"
      :device_key="device_key"
      ref="Del"
    ></Upgrade> -->
  </div>
</template>

<script>
import NewDevice from "@/components/device/new-device";
import NewDeviceBatch from "@/components/device/new-device-batch";
import Del from "@/components/device/del";
import Notice from "@/components/device/give-notice.vue";
// import { ONLINE_TYPE } from "@/common/libs/Contains";
import { copy } from '@/common/libs/utils';

export default {
  components: { NewDevice, NewDeviceBatch, Del, Notice },
  data() {
    return {
      ruleForm:{
        dev_key:''
      },
      rules: {
        dev_key: copy([{
          type: "inputNameInput"
        }])
      },
      NewDeviceloading: false,
      NewDeviceBatchloading: false,
      Delloading: false,
      Noticeloading: false,
      devId: "",
      device_key: '',
      product_key: '',
      currentPage: 1,
      pageSize: 10,
      table: [],
      productOptins: [],
      total: 0,
      dev_name: '',
      dev_status: '',
      filtersList: [{label: '在线', value: 'online'}, {label: '离线', value: 'offline'}]
    };
  },
  created() {
    this.dev_name = this.$route.query.dev_name
    this.getData();
    var _this = this
    this.timer = setInterval(function(){
      _this.getData();
    },1000*60);
  },
  methods: {
    filterChangeEvent(column) {
      this.dev_status = column.values[0]
      this.getData()
    },
    clear () {
      this.ruleForm.dev_key = ''
      this.changePage(1)
    },
    handleSearch () {
      const valid = this.$refs.form.submitForm();
        if (valid === false) {
          return;
        }
      this.changePage(1)
    },
    async getData () {
      const subData = {
        page_num: this.currentPage,
        page_size: this.pageSize,
        app_id: sessionStorage.getItem("appid") || "",
        dev_key: this.$route.query.dev_key,
        dev_status: this.dev_status
      };
      const res = await this.$post(
        "/td/td-iot-api/iot/dev/sub/page/v1",
        subData,
        false
      );
      if (res.code === 0) {
        this.table = res.data.list;
        this.total = res.data.page.total;
        this.table.map((item) => {
          // item.dev_status = ONLINE_TYPE[item.dev_status];
          item.group_name = item.group_name || "无";
        });
      } else {
        if (res.code == "100410") {
          setTimeout(() => {
            this.getData();
          }, 1000);
        } else {
          this.$message.error(res.msg);
        }
      }
    },
    changePage(page) {
      this.currentPage = Number(page);
      this.getData();
    },
    changeSize(size) {
      this.pageSize = Number(size);
      this.currentPage = 1
      this.getData();
    },
    showDelModel(row) {
      this.devId = row.id;
      this.Delloading = !this.Delloading;
    },
    showNoticeModel (row) {
      this.device_key = row.dev_key;
      this.product_key = row.product_key;
      this.Noticeloading = !this.Noticeloading;
    },
    pushBack(){
      this.$router.push({ name: "/deviceInfo-manage/device-list-info" });
    },
    openViewModel(row) {
      //跳转路由
      this.$router.push({
        name: "/deviceInfo-manage/device-details-info",
        query: { name: row.dev_name, id: row.id, key: row.dev_key, isMain: false, mainDevKey: this.$route.query.dev_key, dev_name: this.dev_name },
      });
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>
<style lang="scss">
.headerContainer {
  display: flex;
  align-items: center;
}
.header-list {
  display: inline-block;
  padding: 0px 100px 0px 40px;
  border-left: 1px solid #ebecec;
  .header-list-title {
    font-size: 12px;
    color: #888;
  }
  .header-list-contant {
    font-size: 18px;
    color: #373d41;
  }
}
.online{
    color:#17CC82
  }
.offline{
  color: #F7421E
}
</style>
